import * as React from 'react';
import RouteIfRights from 'pages/router/RouteIfRights';
import OMNILocationsIframe from '.';

const paths = {
  location: '/shop/location',
};

export default [
  <RouteIfRights
    exact
    path={paths.location}
    component={OMNILocationsIframe}
    key={paths.location}
    rights="admin_shops"
  />,
];
